import { DemographyMapper } from '../mapper/DemographyMapper';

export const demographyMapper = new DemographyMapper();
